/* eslint-disable no-use-before-define */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable wrap-iife */
G.Helpers = G.Helpers || {};

// TODO: refactor this to properly handle diffrent scopes. Currently this will not work in all scopes

G.Helpers.gatesMgr = (function () {
  let gatesData = null;
  let saveStateMgr = null;
  let levelDataMgr = null;

  const signals = {
    onGateOpened: new Phaser.Signal(),
    onGateActivated: new Phaser.Signal(),
  };

  const instances = {};

  return {
    signals,
    instances,

    init,
    getGateObject,
    getGateDimensionForLevelIndex,
    addGateInvite,
    activateGate,
    openGate,
    getFirstClosedGateLvLIndex,
    getStarsNeededForNextClosedGate,
    isLevelBehindGate,
    getTimeRequirementForGateInMinutes,
    getUnopenedGatesIds,
    getLevelsToFirstClosedGate,
    unlockGate,
    getFirstClosedGateData,
    getNextGateData,
  };


  function getGateObject(gateId) {
    const gateConfig = getGateConfig(gateId);
    const saveData = getSaveData(gateId);
    return createGateObject(gateConfig, saveData);
  }

  function createGateObject(data, saveData) {
    const mapPosition = levelDataMgr.getMapPosition(getLevelNumber() - 1);

    return {
      getId,
      getTimeRequirementInMinutes,
      getStarsRequirement,
      getPriceOfOpening,
      getLevelNumber,
      getLevelIndex,
      getMapPosition,
      isOpen,
      isReadyToOpen,
      getTimeToOpeningInSeconds,
      getInvitesRequirement,
      getInvitesList,
      getInvitesAvatarsList,
    };

    function getId() {
      return data.id;
    }

    function getMapPosition() {
      return mapPosition;
    }

    function getLevelNumber() {
      return data.lvlNr;
    }

    function getLevelIndex() {
      return getLevelNumber() - 1;
    }

    function getTimeRequirementInMinutes() {
      return data.req.timeMinutes;
    }

    function getTimeToOpeningInSeconds() {
      return Math.ceil(
        (
          saveStateMgr.getUserCooldownRemaining(`gateId_${saveData.gateId}`, '')
        ) / 1000,
      );
    }

    function getStarsRequirement() {
      return data.req.stars;
    }

    function getInvitesRequirement() {
      return data.req.invites || 100;
    }

    function getPriceOfOpening() {
      return data.req.coins;
    }

    function getInvitesList() {
      return saveData.invitesList || [];
    }

    function getInvitesAvatarsList() {
      return saveData.avatarsList || [];
    }

    function isOpen() {
      return saveData.open;
    }

    function isReadyToOpen() {
      return saveData.readyToOpen;
    }
  }

  function init(data) {
    saveStateMgr = G.saveState;
    levelDataMgr = G.Helpers.levelDataMgr;
    gatesData = data || gatesData;

    G.sb('onWallClockTimeUpdate').addPermanent(tickCheckGate, null, 99);
    tickCheckGate();
  }

  function getGateConfig(gateId) {
    return gatesData.find(function (gate) {
      return gate.id === gateId;
    });
  }

  function getSaveData(gateId) {
    if (!saveStateMgr.data.gates[gateId]) {
      saveStateMgr.data.gates[gateId] = {
        open: false,
        timerStartedAt: -1,
        invites: 0,
        gateId,
      };
    }

    return saveStateMgr.data.gates[gateId];
  }

  function activateGate(gateId) {
    const gateObj = getGateObject(gateId);
    const saved = getSaveData(gateId);

    if (saved.timerStartedAt === -1) {
      checkGate(gateId);
      // saved.timerStartedAt = Date.now();
      saved.timerStartedAt = (gateObj.getTimeRequirementInMinutes() * 60 * 1000);
      saveStateMgr.setUserCooldown(`gateId_${gateId}`, '', saved.timerStartedAt);
      saveStateMgr.save();
      signals.onGateActivated.dispatch(gateId, saved.readyToOpen);
    }
  }

  function openGate(gateId) {
    const savedData = getSaveData(gateId);
    savedData.open = true;
    signals.onGateOpened.dispatch(gateId);
    saveStateMgr.save();
  }

  function unlockGate(gateId) {
    const savedData = getSaveData(gateId);
    savedData.readyToOpen = true;
    saveStateMgr.save();
  }

  function tickCheckGate() {
    let newReadyToOpen = false;
    gatesData.forEach(function (gate) {
      if (checkGate(gate.id)) {
        newReadyToOpen = true;
      }
    });
    if (newReadyToOpen) saveStateMgr.save();
  }

  /**
   * check gate status
   * @param {string} gateId
   * @return {boolean} true if a new gate is ready to open
   */
  function checkGate(gateId) {
    const savedData = getSaveData(gateId);
    const gateData = getGateConfig(gateId);

    if (savedData.open || savedData.readyToOpen) {
      return false;
    }

    const allUserStars = saveStateMgr.getAllStars();

    if (allUserStars >= gateData.req.stars) {
      savedData.readyToOpen = true;
    }

    if (savedData.timerStartedAt > -1) {
      if (saveStateMgr.getUserCooldownRemaining(`gateId_${gateId}`, '') === 0) {
        savedData.readyToOpen = true;
      }
    }

    if (savedData.invites >= gateData.req.invites) {
      savedData.readyToOpen = true;
    }
    return savedData.readyToOpen;
  }

  function isGateOpen(gateId) {
    return getSaveData(gateId).open;
  }

  function addGateInvite(gateId, playerId, playerAvatar) {
    const result = {
      inviteAccepted: false,
      gateObject: false,
    };

    const gateData = getGateConfig(gateId);
    const gateSaveData = getSaveData(gateId);

    if (gateData && gateSaveData && !gateSaveData.open) {
      result.gateObject = getGateObject(gateId);
      if (!gateSaveData.invitesList) gateSaveData.invitesList = [];
      if (!gateSaveData.avatarsList) gateSaveData.avatarsList = [];
      if (gateSaveData.invitesList.indexOf(playerId) === -1) {
        gateSaveData.invitesList.push(playerId);
        gateSaveData.avatarsList.push(playerAvatar);
        gateSaveData.invites++;
        result.inviteAccepted = true;

        // Doesn't work the same way as before. Taken out in favour of the user clicking it to unlock
        // if (gateSaveData.invites >= gateData.req.invites) {
        //   gateSaveData.open = true;
        // }

        saveStateMgr.save();
      }
    }
    return result;
  }

  function getGateDimensionForLevelIndex(levelIndex) {
    const gatesLvlNr = [0].concat(gatesData.map(function (gate) {
      return gate.lvlNr;
    }));

    let i = 0; // i needs to be referenced outside of loop
    for (i = 0; i < gatesLvlNr.length; i++) {
      if (levelIndex < gatesLvlNr[i] - 1) {
        return i - 1;
      }
    }

    return i - 1;
  }

  function getFirstClosedGateData() {
    for (let i = 0; i < gatesData.length; i++) {
      if (!getSaveData(gatesData[i].id).open) {
        return gatesData[i];
      }
    }
    return null;
  }

  function getFirstClosedGateLvLIndex() {
    for (let i = 0; i < gatesData.length; i++) {
      if (!getSaveData(gatesData[i].id).open) {
        return gatesData[i].lvlNr - 1;
      }
    }
    return null;
  }

  function getNextGateData(gateId) {
    const curIndex = gatesData.findIndex((gate) => gate.id === gateId);
    if (curIndex === gatesData.length - 1) {
      return null;
    }

    return gatesData[curIndex + 1];
  }

  function getLevelsToFirstClosedGate() {
    const gateLvlIndex = getFirstClosedGateLvLIndex();
    if (!gateLvlIndex) return 0; // no more gates
    const lastPassedLevelNr = saveStateMgr.getLastPassedLevelNr();
    return gateLvlIndex - lastPassedLevelNr;
  }

  function getStarsNeededForNextClosedGate() {
    const gateData = getFirstClosedGateData();
    if (!gateData) return 0;
    return gateData.req.stars - saveStateMgr.getAllStars();
  }

  function isLevelBehindGate(levelIndex) {
    for (let i = 0; i < gatesData.length; i++) {
      if (gatesData[i].lvlNr === levelIndex + 1) {
        return !getSaveData(gatesData[i].id).open;
      }
    }

    return false;
  }

  function getTimeRequirementForGateInMinutes(gateId) {
    const gate = getGateConfig(gateId);
    if (!gate) return null;
    return gate.req.timeMinutes;
  }

  function getUnopenedGatesIds() {
    return gatesData.map(function (gateData) {
      return gateData.id;
    }).filter(function (gateId) {
      return !isGateOpen(gateId);
    });
  }
})();
